import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const useGetMaxQuantityShownColumns = () => {
  const screens = useBreakpoint();
  const isMobileScreen = !screens.sm;
  const isTabletScreen = screens.sm && !screens.md;
  const isLaptopScreen = (screens.md || screens.xl) && !screens.xxl;

  return isMobileScreen ? 4 : isTabletScreen || isLaptopScreen ? 8 : 12;
};
